const MtrCheckOutline={
    "name": "mtr-check",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 24 24",
            "fill": "none"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M6.36182 11.7988L6.29182 11.8688C6.19861 11.9623 6.12484 12.0733 6.07476 12.1955C6.02467 12.3176 5.99927 12.4485 6.00002 12.5805C6.00076 12.7125 6.02763 12.843 6.07909 12.9646C6.13055 13.0862 6.20557 13.1964 6.29982 13.2888L10.0788 16.9958L17.3638 9.7888C17.4575 9.69614 17.532 9.58587 17.5829 9.46434C17.6338 9.34281 17.6602 9.21241 17.6606 9.08064C17.661 8.94886 17.6353 8.81832 17.5851 8.6965C17.5348 8.57468 17.461 8.46399 17.3678 8.3708L17.2908 8.2938C17.1976 8.20034 17.0868 8.12625 16.9648 8.07583C16.8428 8.0254 16.712 7.99963 16.58 8C16.448 8.00038 16.3173 8.02688 16.1956 8.07799C16.0739 8.12911 15.9635 8.20381 15.8708 8.2978L10.0788 14.1678L7.78582 11.8088C7.69345 11.7138 7.58313 11.6381 7.46126 11.5861C7.33939 11.5342 7.2084 11.5069 7.07591 11.506C6.94342 11.505 6.81207 11.5305 6.68948 11.5807C6.56689 11.631 6.45551 11.7051 6.36182 11.7988V11.7988Z",
                    "fill": "currentColor"
                }
            }
        ]
    }
};
export default MtrCheckOutline;